import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PickColorIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m7.144 4.62 4.236 4.236M2 14s2.723-.303 4.236-1.816L13.5 4.922a1.712 1.712 0 1 0-2.421-2.42L3.816 9.763C2.303 11.277 2 14 2 14" /></svg>
  );
}

export default PickColorIcon;
